import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import { postRequest } from '../../requestUtils';
import './AskQuestion.scss';

class AskQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: '',
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event) {
    const { target } = event;
    const { value } = target;
    const { name } = target;
    this.setState({
      [name]: value,
    });
  }

  handleSubmit() {
    const { formUrl, csrfToken, redirectUrl } = this.props;
    const data = this.state;

    return postRequest(
      formUrl,
      data,
      csrfToken,
    ).then((resp) => {
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        window.location.href = resp.data.redirect;
      }
    }).catch((err) => {
      this.setState({ errors: err });
    });
  }

  render() {
    const {
      triggerText,
      submitButtonText,
      headerTitle,
      recipientName,
      triggerType,
      bodyText,
      buttonStyles,
      required,
    } = this.props;

    const defaultBodyText = `Submitting a request for edits will send an email to ${recipientName} directing them to edit this proposal. `
    + 'They will be able to view your comments on this page and in the email.';

    return (
      <ModalTrigger
        triggerText={triggerText}
        buttonStyles={buttonStyles || 'default'}
        submitButtonText={submitButtonText}
        handleSubmit={this.handleSubmit}
        submitDisabled={required && !this.state.text}
        triggerType={triggerType}
        idKey="ask-question-modal"
        modalSize="md"
      >
        <div className="approve-invoice-modal style-guide">
          <h2 className="mb-3">{headerTitle}</h2>
          <p className="body-text-2 mb-4">{bodyText || defaultBodyText}</p>
        </div>
        <textarea
          value={this.state.text}
          className="form-control"
          placeholder="Type here..."
          name="text"
          id="text"
          rows="4"
          onChange={this.handleInputChange}
        />
      </ModalTrigger>
    );
  }
}

AskQuestion.propTypes = {
  formUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  recipientName: PropTypes.string,
  triggerText: PropTypes.string,
  submitButtonText: PropTypes.string,
  headerTitle: PropTypes.string,
  triggerType: PropTypes.string,
  bodyText: PropTypes.string,
  redirectUrl: PropTypes.string,
  buttonStyles: PropTypes.string,
  required: PropTypes.bool,
};

AskQuestion.defaultProps = {
  triggerText: 'Request Edits',
  submitButtonText: 'Request Edits',
  headerTitle: 'Request edits on this proposal',
  triggerType: 'button',
  bodyText: null,
  redirectUrl: null,
  buttonStyles: null,
  required: true,
  recipientName: '',
};

export default AskQuestion;
